// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__n0jPf","colMin":"styles_colMin__1hbCx","colCheckbox":"styles_colCheckbox__39lVg"};